import { Injectable } from '@angular/core';
import { MonitoredTrain } from '../models/monitored-train';
import { MQTTGps, MQTTLTEStatistic, MQTTLinkSession, MQTTLinkStatistic, MQTTPassiveScanning, MQTTRadioUserCount, MQTTTrainUser } from '../models/mqtt-data';
import { Operator } from '../../sims/models/operator';
import { MQTTData } from '../models/mqtt-data';

@Injectable({
  providedIn: 'root'
})
export class MqttTrainDataService {

  constructor() { }

  process = (data: MQTTData, currentTrain: MonitoredTrain, simOperators: Operator[]) => {
    switch (data.messageInfo) {
      case  "MAR3_GPS":
        data = data as MQTTGps;
        return {
          ...currentTrain,
          lastGpsUpdate: data.timestamp,
          speed:  data.gpsData && data.gpsData.speed * 3.6 || currentTrain.speed,
          heading:  data.gpsData && data.gpsData.heading || currentTrain.heading,
          currentPosition: data && data.gpsData && data.gpsData.position ? (data.gpsData && data.gpsData.position) : currentTrain.currentPosition
        }

      case "MAR3_LINK_STATISTICS_V1":
      case "MAR3_LTE_STATISTICS_V1":
      case "MAR3_LINK_SESSION_V1":
        data = data as MQTTLinkStatistic | MQTTLTEStatistic;
        //@ts-ignore
        const operator = simOperators && simOperators.find(op => op.code === String(data.operatorCode))
        //console.log("operator:", operator)
        const mqttLinkName = "b" + data.boxId.toString() + "-" + data.link.toLowerCase().replace("_", "-")
        return {
          ...currentTrain,
          links: currentTrain.links && currentTrain.links.map(link => {
            if ((link.projectId === data.projectId) && (link.trainId === data.trainId) && (mqttLinkName === link.name)) {
              return operator ? {
                ...link,
                ...data,
                operator
              } : {
                ...link,
                ...data
              }
            }
            return {
              ...link
            }
          })
        }

      case "RADIO_USER_COUNT_V1":
      case "TRAINUSER_V1":
      case "PASSIVE_SCANNING_V1":
          data = data as MQTTTrainUser | MQTTRadioUserCount | MQTTPassiveScanning
          return {
            ...currentTrain,
            users: currentTrain.users.map(user => {
              if ((user.projectId === data.projectId) && (user.relativeTrainId === data.trainId) && (user.boxId === data.boxId)) {
                return {
                  ...user,
                  ...data
                }
              }
              return {
                ...user
              }
            })
          }
      default:
        return currentTrain
    }
  }
   
}
